import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import {
  Category,
  Product,
  ProductScope,
  ProductSearchPage,
  ProductSearchService,
  ProductService,
  isNotUndefined
} from '@spartacus/core';
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';
import { Observable, Subscription, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CustomCategoryService } from './services/custom-category.service';
import { getAllCategoryState } from './store/selectors/custom-category.selectors';

@Component({
  selector: 'app-custom-header-category',
  templateUrl: './custom-header-category.component.html',
  styleUrls: ['./custom-header-category.component.scss'],
  standalone: false
})
export class CustomHeaderCategoryComponent implements OnInit, OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  category$: Observable<Category>;
  productCodes$: Observable<string>;
  code: string;
  codes: string;
  items$: Observable<Observable<Product>[]>;
  carouselType = 'ProductCarouselComponent';
  cmsItemType = 'CMSItemComponent';
  animation = 'swipe';

  protected readonly PRODUCT_SCOPE = ProductScope.LIST;

  constructor(
    protected productSearchService: ProductSearchService,
    protected categoryService: CustomCategoryService,
    private store: Store,
    protected route: ActivatedRoute,
    protected productService: ProductService,
    protected breakpointService: BreakpointService,
    protected cd: ChangeDetectorRef,
  ) {
    this.route.paramMap.subscribe(params => {
      this.code = params.get('categoryCode');
      this.categoryService.loadCategory(this.code);
    }).unsubscribe();
  }

  searchResults$: Observable<ProductSearchPage> = this.productSearchService
    .getResults()
    .pipe(filter((searchResult) => Object.keys(searchResult).length > 0));

  ngOnInit(): void {
    this.category$ = this.store.pipe(select(getAllCategoryState));

    this.subscriptions.add(this.category$.subscribe((components: any) => {
      components?.component?.map(component => {
        if (component.typeCode === this.carouselType) {
          this.productCodes$ = of(component.productCodes);
          this.items$ = this.productCodes$.pipe(
            map((data) => data.trim().split(' ') ?? []),
            map((codes) =>
                codes.map((code) => this.productService.get(code, this.PRODUCT_SCOPE)),
              map(filter(isNotUndefined))
            )
          );
        }
      });
    }));

    this.productSearchService
      .getResults()
      .pipe(filter((searchResult) => Object.keys(searchResult).length > 0)).subscribe(data => { })
  }

  isMobile(): Observable<boolean> {
    return this.breakpointService?.isDown(BREAKPOINT.sm);
  }

  ngOnDestroy(): void {
    this.productSearchService.clearResults();
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
